import React from "react";
import classNames from "classnames";
import * as c from "./blogSubscribeBanner.module.scss";
import { EmailCaptureForm } from "@components/shared";

const BlogSubscribeBanner = ({ className }) => {
  return (
    <aside className={classNames(className, c.container)}>
      <div className={c.wrapper}>
        <h4 className={c.heading}>Get the latest stories straight to your inbox.</h4>
        <EmailCaptureForm formSource="blog_subscribe_form" variant="inline" />
      </div>
    </aside>
  );
};

export { BlogSubscribeBanner };
